export default "__VITE_ASSET__BnmX9SwO__"